export default __webpack_public_path__ + "static/media/547.98607ba1.png";